import { useMemo } from 'react';

/** Resolve a { fr, en, ar } dict for the given lang (falls back to fr). */
export function resolveT(dict, lang) {
  return dict[lang] ?? dict.fr;
}

/** Hook: memoized translation dict for a page-level T object. */
export function usePageT(dict, lang) {
  return useMemo(() => resolveT(dict, lang), [dict, lang]);
}

/** Hook: memoized key-based translator (like useAppT). */
export function useKeyT(dict, lang) {
  return useMemo(() => {
    const d = resolveT(dict, lang);
    const fallback = dict.fr;
    return function t(key, ...args) {
      const val = d[key] ?? fallback[key] ?? key;
      return typeof val === 'function' ? val(...args) : val;
    };
  }, [dict, lang]);
}
